import { default as ExerciseSidebar } from './ExerciseSidebarContainer';

export default ExerciseSidebar;
